// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/antd/dist/reset.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Outfit:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Float UI Design System */
:root {
  /* Palette - Vibrant & Premium */
  --float-primary: #4f46e5; /* Indigo 600 */
  --float-primary-light: #818cf8;
  --float-secondary: #ec4899; /* Pink 500 */
  --float-accent: #8b5cf6; /* Violet 500 */
  
  /* Gradients */
  --gradient-primary: linear-gradient(135deg, #4f46e5 0%, #ec4899 100%);
  --gradient-glass: linear-gradient(145deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 100%);
  --gradient-surface: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  
  /* Backgrounds */
  --bg-app: #f3f4f6;
  --bg-glass: rgba(255, 255, 255, 0.7);
  
  /* Shadows */
  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --shadow-float: 0 20px 40px rgba(79, 70, 229, 0.15); /* Colored shadow */
  
  /* Animation */
  --anim-hover: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: var(--bg-app);
  color: #1e293b;
  background-image: 
    radial-gradient(at 0% 0%, rgba(79, 70, 229, 0.1) 0px, transparent 50%),
    radial-gradient(at 100% 0%, rgba(236, 72, 153, 0.1) 0px, transparent 50%);
  background-attachment: fixed;
}

/* Glassmorphism Utilities */
.glass-panel {
  background: var(--bg-glass);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: var(--shadow-lg);
}

.glass-card {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: var(--shadow-md);
  border-radius: 16px;
  transition: var(--anim-hover);
}

.glass-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-float);
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(255, 255, 255, 0.8);
}

/* Typography */
h1, h2, h3, h4, h5, h6 {
  font-family: 'Outfit', 'Inter', sans-serif;
  font-weight: 600;
  color: #0f172a;
}

.text-gradient {
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Animations */
@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-6px); }
  100% { transform: translateY(0px); }
}

.animate-float {
  animation: float 4s ease-in-out infinite;
}

/* Ant Design Overrides for Float UI Feel */
.ant-card {
  border-radius: 16px !important;
  border: 1px solid rgba(255, 255, 255, 0.6) !important;
  box-shadow: var(--shadow-sm) !important;
  transition: var(--anim-hover) !important;
  overflow: hidden;
}

.ant-card:hover {
  box-shadow: var(--shadow-float) !important;
  transform: translateY(-2px);
}

.ant-btn {
  border-radius: 8px;
  font-weight: 500;
  transition: var(--anim-hover);
}

.ant-btn-primary {
  background: var(--gradient-primary);
  border: none;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
}

.ant-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4) !important;
  opacity: 0.9;
}

.ant-pro-layout-sider-children {
  background: rgba(255, 255, 255, 0.5) !important;
  backdrop-filter: blur(10px);
}

.ant-menu {
  background: transparent !important;
}

.ant-layout {
  background: transparent !important;
}

.ant-layout-header {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(12px) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/renderer/assets/global.css"],"names":[],"mappings":"AAGA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,wBAAwB,EAAE,eAAe;EACzC,8BAA8B;EAC9B,0BAA0B,EAAE,aAAa;EACzC,uBAAuB,EAAE,eAAe;;EAExC,cAAc;EACd,qEAAqE;EACrE,qGAAqG;EACrG,qEAAqE;;EAErE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;;EAEpC,YAAY;EACZ,0CAA0C;EAC1C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;EACtF,mDAAmD,EAAE,mBAAmB;;EAExE,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,uFAAuF;EACvF,yBAAyB;EACzB,cAAc;EACd;;6EAE2E;EAC3E,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;EAClC,0CAA0C;EAC1C,4BAA4B;EAC5B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,KAAK,0BAA0B,EAAE;EACjC,MAAM,2BAA2B,EAAE;EACnC,OAAO,0BAA0B,EAAE;AACrC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,2CAA2C;AAC3C;EACE,8BAA8B;EAC9B,qDAAqD;EACrD,uCAAuC;EACvC,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,wDAAwD;EACxD,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+CAA+C;EAC/C,sCAAsC;EACtC,iDAAiD;AACnD","sourcesContent":["@import 'antd/dist/reset.css';\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Outfit:wght@400;500;600;700&display=swap');\n\n/* Float UI Design System */\n:root {\n  /* Palette - Vibrant & Premium */\n  --float-primary: #4f46e5; /* Indigo 600 */\n  --float-primary-light: #818cf8;\n  --float-secondary: #ec4899; /* Pink 500 */\n  --float-accent: #8b5cf6; /* Violet 500 */\n  \n  /* Gradients */\n  --gradient-primary: linear-gradient(135deg, #4f46e5 0%, #ec4899 100%);\n  --gradient-glass: linear-gradient(145deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 100%);\n  --gradient-surface: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  \n  /* Backgrounds */\n  --bg-app: #f3f4f6;\n  --bg-glass: rgba(255, 255, 255, 0.7);\n  \n  /* Shadows */\n  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  --shadow-float: 0 20px 40px rgba(79, 70, 229, 0.15); /* Colored shadow */\n  \n  /* Animation */\n  --anim-hover: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  background: var(--bg-app);\n  color: #1e293b;\n  background-image: \n    radial-gradient(at 0% 0%, rgba(79, 70, 229, 0.1) 0px, transparent 50%),\n    radial-gradient(at 100% 0%, rgba(236, 72, 153, 0.1) 0px, transparent 50%);\n  background-attachment: fixed;\n}\n\n/* Glassmorphism Utilities */\n.glass-panel {\n  background: var(--bg-glass);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-shadow: var(--shadow-lg);\n}\n\n.glass-card {\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  box-shadow: var(--shadow-md);\n  border-radius: 16px;\n  transition: var(--anim-hover);\n}\n\n.glass-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-float);\n  background: rgba(255, 255, 255, 0.95);\n  border-color: rgba(255, 255, 255, 0.8);\n}\n\n/* Typography */\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Outfit', 'Inter', sans-serif;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.text-gradient {\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Animations */\n@keyframes float {\n  0% { transform: translateY(0px); }\n  50% { transform: translateY(-6px); }\n  100% { transform: translateY(0px); }\n}\n\n.animate-float {\n  animation: float 4s ease-in-out infinite;\n}\n\n/* Ant Design Overrides for Float UI Feel */\n.ant-card {\n  border-radius: 16px !important;\n  border: 1px solid rgba(255, 255, 255, 0.6) !important;\n  box-shadow: var(--shadow-sm) !important;\n  transition: var(--anim-hover) !important;\n  overflow: hidden;\n}\n\n.ant-card:hover {\n  box-shadow: var(--shadow-float) !important;\n  transform: translateY(-2px);\n}\n\n.ant-btn {\n  border-radius: 8px;\n  font-weight: 500;\n  transition: var(--anim-hover);\n}\n\n.ant-btn-primary {\n  background: var(--gradient-primary);\n  border: none;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n}\n\n.ant-btn-primary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4) !important;\n  opacity: 0.9;\n}\n\n.ant-pro-layout-sider-children {\n  background: rgba(255, 255, 255, 0.5) !important;\n  backdrop-filter: blur(10px);\n}\n\n.ant-menu {\n  background: transparent !important;\n}\n\n.ant-layout {\n  background: transparent !important;\n}\n\n.ant-layout-header {\n  background: rgba(255, 255, 255, 0.8) !important;\n  backdrop-filter: blur(12px) !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
